import script from "./svc-reqst-dl.vue?vue&type=script&setup=true&lang=js"
export * from "./svc-reqst-dl.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__